import { SectionData } from "./data"
import { Element } from "./element"
import { Column } from "./column"

export class Section<Outer extends boolean = true> extends Element {
  cols: Array<Column<Outer>>

  constructor(data: SectionData) {
    super(data);

    if (data.elements) {
      this.cols = data.elements.map((data) => {
        if (data.elType === "column") {
          return new Column<Outer>(data)
        } else {
          throw new TypeError(`unrecognized element type "${data.elType}"`);
        }
      });
    } else {
      this.cols = [];
    }
  }
}

export type InnerSection = Section<false>;

